import { Axios } from "../utils/axios.js";

// 考生列表查询
export const tableGet = params => {
  return Axios.get(`/education-member-admin/memberExaminee/list`, { params });
};
//考生新增
export const dataAdd = data => {
  return Axios.post("/education-member-admin/memberExaminee", data);
};

//考生删除
export const dataDelete = id => {
  return Axios.delete(`/education-member-admin/memberExaminee/${id}`);
};

// 考生编辑
export const dataUpdate = data => {
  return Axios.put(`/education-member-admin/memberExaminee`, data);
};

//考生导入
export const dataUpload = data => {
  return Axios.post("/education-member-admin/memberExaminee/import", data, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  });
};



// WEBPACK FOOTER //
// ./src/api/student.js